import React from 'react';
import { Box, Button } from '@zillow/constellation-10';
import { IconSendOutline } from '@zillow/constellation-icons';
import CompactAddMessageLayout from '../CompactAddMessageLayout';
import TooltipWrapper from '../TooltipWrapper';
import { addMessageWrapperStyles, desktopLayoutStyles, mobileLayoutStyles } from './styles';

export type AddMessageLayoutProps = {
  children: React.ReactNode;
  leftButtons?: React.ReactNode;
  onSend: () => void;
  isSendDisabled?: boolean;
  sendMessageDataEventId?: string;
};

const AddMessageLayout = React.forwardRef<HTMLDivElement, AddMessageLayoutProps>(
  ({ children, leftButtons, onSend, isSendDisabled = false, sendMessageDataEventId }, ref) => {
    const desktopLayout = (
      <>
        {/* Textarea */}
        <Box
          css={{
            width: '100%',
          }}
        >
          {children}
        </Box>

        <Box
          css={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          {/* Left Buttons Slot */}
          {leftButtons}

          {/* Send Button */}
          <TooltipWrapper
            wrapInTooltip={!isSendDisabled}
            tooltipText="Send message (Enter/Return)"
            tooltipPlacement="top"
            delayMs={300}
          >
            <Button
              data-eventid={sendMessageDataEventId}
              tone="brand"
              emphasis="filled"
              onClick={() => onSend()}
              disabled={isSendDisabled}
              icon={<IconSendOutline />}
            >
              Send
            </Button>
          </TooltipWrapper>
        </Box>
      </>
    );

    return (
      <Box ref={ref} data-testid="add-message-layout" css={addMessageWrapperStyles}>
        {/* Desktop Layout */}
        <Box css={desktopLayoutStyles}>{desktopLayout}</Box>

        {/* Mobile Layout - uses CompactAddMessageLayout */}
        <Box css={mobileLayoutStyles}>
          <CompactAddMessageLayout
            leftButtons={leftButtons}
            onSend={onSend}
            isSendDisabled={isSendDisabled}
            sendMessageDataEventId={sendMessageDataEventId}
          >
            {children}
          </CompactAddMessageLayout>
        </Box>
      </Box>
    );
  },
);

AddMessageLayout.displayName = 'AddMessageLayout';

export default AddMessageLayout;
